
import { computed, defineComponent } from 'vue'
import store from '@/store'
import UserInfo from '@/components/Shared/UserInfo.vue'

export default defineComponent({
  components: {
    UserInfo
  },
  emits: ['logout'],
  setup() {
    const user = computed(() => store.state.auth.user)
    return { user }
  }
})
